module.exports = __webpack_public_path__ + "img/default2.cf10043d.png";